export default __webpack_public_path__ + "static/media/deliver.9a2bdce0.svg";